export default __webpack_public_path__ + "static/media/make-move.928903fe.wav";